import React, { useState } from 'react'
import { cuteToast } from '../../UI/cute';
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";
import { useSelector } from 'react-redux';

const SendTestMail = ({setShowTestmailModal,subject,emailContent}) => {

    const { sendRequest: sendMailRequest } = useHttp();

    const [inputFields,setInputFields] = useState([
        {
            email:"",
            fname:"",
            companyName:"",
            error:"Please Enter Your Email Here"
        }
    ])

    const first_name = useSelector((state) => state.auth.first_name);
    const checkSmtp = useSelector((state) => state.settings.smtp_details);
    
    const [showSmtp,setShowSmtp] = useState({
        detailsFlag:false,
        passwordFlag:false,
        password:""

    });

    const handleCancel = () =>{

        setInputFields({
            ...inputFields,
            email:"",
            fname:"",
            companyName:""
        })
        setShowSmtp({
            ...showSmtp,
            detailsFlag:false,
            passwordFlag:false
        });
        setShowTestmailModal(false)
    }

    const handleProcess = (event) =>{
        // console.log('here')
        event.preventDefault();
        event.target.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Sending...';
        let newcontent;
        let emailSubject;

        if(inputFields.filter( fields=>fields.error).length > 0){
            cuteToast({
                type: "error",
                message: `Please check entered email!`,
                timer: 3000,
                title: "Invalid Email",
            });
            event.target.innerHTML = 'Send Test Mail';
        }else if(showSmtp.password && showSmtp.password.length > 0){
                
                newcontent = emailContent
                // newcontent = newcontent.replaceAll("${User.First Name}",first_name)
                const regex = /\$\{User.First Name\}/ig;
                
                newcontent = newcontent.replaceAll(regex,first_name)
                newcontent = newcontent.replaceAll(/\$\{User.Company Name\}/ig,"VidAmaze")
                emailSubject = subject.replaceAll(regex,first_name)
            
                sendMailRequest(
                    {
                    url: endPoints.sendMailData,
                    method: "POST",
                    body: {
                        content:newcontent,
                        sendto: JSON.stringify(inputFields),
                        subject:emailSubject,
                        password:showSmtp.password
                        },
                    },
                    (response) => {
                        if (response.status === 200) {
                            //   console.log(response)
                            cuteToast({
                                type: "success",
                                message: "Send Successfully.",
                                timer: 5000,
                                title: "Email",
                            });
                            setShowTestmailModal(false);
                        }else{
                            cuteToast({
                                type: "error",
                                message: "Please check your password!",
                                timer: 3000,
                                title: "Something Went Wrong!",
                            });
                        }
                        event.target.innerHTML = 'Send Test Mail';
                    }
                );
        }else if(showSmtp.passwordFlag && showSmtp.password.length === 0){
                cuteToast({
                    type: "error",
                    message: "Please Enter Your Smtp Password!",
                    timer: 3000,
                    title: "",
                });
                event.target.innerHTML = 'Send Test Mail';
        }else if(checkSmtp && Object.keys(checkSmtp).length === 0){
                // console.log(checkSmtp)
                setShowSmtp({
                    ...showSmtp,
                    passwordFlag:false
                });
                cuteToast({
                    type: "error",
                    message: "You haven't saved your smtp details under setting page.",
                    timer: 3000,
                    title: "",
                });

                event.target.innerHTML = 'Send Test Mail';
        }
       
    }

    const isValidEmail = email =>
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
    );

    const handleChange = (e,index,type) =>{
        // console.log(index,type)
        var clone = [...inputFields]

        const isValid = isValidEmail(e.target.value);

        var obj = clone[index];

        if(type === 'email'){
            if(isValid){
                obj["error"] = false 
                setShowSmtp({
                    ...showSmtp,
                    detailsFlag:false,
                    passwordFlag:true
                });
            }else{
                obj["error"] = true  
            }
        }
        obj[type] = e.target.value
        clone[index]= obj; 
        setInputFields(clone)
    }
    

    return (
        <div className={`modal popup1 d-block fade show`} id="importContacts" style={{background: "#000000ba"}}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Test Mail</h5>
                            <button
                                type="button"
                                className="close_btn"
                                style={{ position: 'inherit' }}
                                onClick={handleCancel}
                            ><i className="fa fa-close"></i></button>
                        </div>
                        <div className="modal-body navpill_section p-4">
                           
                            <div className="tab-content p-4 pb-0" id="nav-tabContent">
                            
                                <div className={`tab-pane fade show active`} id="nav-libraryimages" role="tabpanel" aria-labelledby="nav-libraryimages-tab">
                                    <div className="recordedvideo">
                                        <div className="row">
                                            <div className="col-md-12 mb-4">
                                                {inputFields && inputFields.map((row,index)=>(
                                                    <div className='row' key={index}>
                                                        <div className="col-md-3 col-6">
                                                            <div className="rv_col mb-4">
                                                                <input 
                                                                    className={`form-control ${row.error ? "is-invalid" : ""}`}
                                                                    placeholder='Email'
                                                                    onChange={(e)=>handleChange(e,index,'email')}
                                                                    value={row.email}
                                                                />
                                                                {row.error && (
                                                                    <div className="invalid-feedback">
                                                                        Please Enter Valid Email!.
                                                                    </div>
                                                                )}
                                                                
                                                            </div>
                                                        </div>
                                                       
                                                        <div className="col-md-3 col-6">
                                                            <div className="rv_col mb-4">
                                                                <input 
                                                                    className="form-control"
                                                                    placeholder='First Name'
                                                                    value={row.fname} 
                                                                    onChange={(e)=>handleChange(e,index,'fname')}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-6">
                                                            <div className="rv_col mb-4">
                                                                <input 
                                                                    className="form-control"
                                                                    placeholder='Company Name' 
                                                                    value={row.companyName}
                                                                    onChange={(e)=>handleChange(e,index,'companyName')}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                
                                                {(showSmtp && showSmtp.passwordFlag) && (
                                        
                                                    <div className='row'>
                                                        <div className='smtp-container my-4'>
                                                            <div className="form-group row">
                                                                <label 
                                                                    htmlFor="smtpPassword" 
                                                                    className="col-sm-2 col-form-label h5"
                                                                >Smtp Password</label>
                                                                <div className="col-sm-8">
                                                                <input 
                                                                    type="password" 
                                                                    className="form-control" 
                                                                    id="smtpPassword" 
                                                                    placeholder="Please Enter Your Password"
                                                                    onChange={(e)=>setShowSmtp({...showSmtp,password:e.target.value})}
                                                                />
                                                                </div>
                                                            </div>
                                                    </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="iv_footer">
                                            <div className="btn_wrap_p text-end">
                                                <button className="btn btn2 me-2" onClick={handleCancel}>Cancel</button>
                                                <button className="btn btn1" onClick={handleProcess}>Send Test Mail</button></div>
                                        </div>

                                    </div>
                                </div>

                            </div>


                        </div>

                    </div>
                </div>
        </div>
    )
}

export default SendTestMail;